<template>
  <div v-if="isExternal" :style="styleExternalIcon" class="svg-external-icon svg-icon" v-on="$attrs" />
  <svg v-else :class="svgClass" :style="{ width: width, height: height }" aria-hidden="true" v-on="$attrs">
    <use :xlink:href="iconName" :fill="color" />
  </svg>
</template>

<script setup lang="ts">
// 组件使用，图标需要放置@/assets/icons文件夹下，图标名字需要跟name="图标名称"保持一致。
// <SvgIcon name="lc-mobile-menu" width="30px" height="30px"></SvgIcon>
import { computed } from "vue";

const props = defineProps({
  name: {
    type: String,
    default: "",
  },

  color: {
    type: String,
    default: "",
  },

  width: {
    type: String,
    default: "",
  },

  height: {
    type: String,
    default: "",
  },

  className: {
    type: String,
    default: "",
  },
});

const isExternalString = (path: string) => {
  return /^(https?:|mailto:|tel:)/.test(path);
};

const isExternal = computed(() => {
  return isExternalString(props.name as string);
});

const iconName = computed(() => {
  return `#icon-${props.name}`;
});

const svgClass = computed(() => {
  if (props.name) {
    return "svg-icon " + props.name;
  } else {
    return "svg-icon";
  }
});

const styleExternalIcon = computed(() => {
  return {
    mask: `url(${props.name}) no-repeat 50% 50%`,
    "-webkit-mask": `url(${props.name}) no-repeat 50% 50%`,
  };
});
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover;
  display: inline-block;
}
</style>
